export const APPLICATION_ID = 'CustomerPortal';
